import { createSelector, createSlice } from '@reduxjs/toolkit'

/**
 *
 * Selectors
 *
 */
export const selectRootAccounts = (state) => state.root.accounts
export const selectRootUser = (state) => state.root.user
/** Raw team permission rows from login (includes page, mcp_tool, integration_manage). */
export const selectRootAccessPermission = (state) =>
  (state.root.user?.access_permission as Array<Record<string, unknown>> | undefined) ?? []
export const selectRootDomains = (state) => state.root.domains
export const selectRootAdmin = (state) => state.root.admin
export const selectRootPermissions = (state) => state.root.permissions
export const selectRootAccessPermissions = (state) => state.root.accessPermissions || []
export const selectRootUserDefaultTimezone = (state) => state.root.user.default_timezone
export const selectRootUserDefaultCurrency = (state) => state.root.user.default_currency
export const selectRootUserDefaultCurrencyShouldAutoFilter = (state) =>
  state.root.user?.currencysettings?.auto_filter_default_currency
